import { mockTemplateData } from './mockData';
import api from './api';
import endpoints from './endpoints';

export const getTemplateContent = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockTemplateData);
    }, 500);
  });
};

export const updateTemplateContent = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ ...data });
    }, 500);
  });
}; 

// 新增：创建模板API
const createTemplate = async (data) => {
  // type 固定为 personal
  return api.post(endpoints.template.create, { ...data, type: 'personal' });
};

const templateService = {
  getTemplateContent,
  updateTemplateContent,
  createTemplate,
};

export default templateService; 